import * as React from 'react';

import { ServiceType } from '../../../../../../CardExtra/types';
import CdnImage from '../../../../../../CdnImage';

interface Props {
	type: ServiceType;
	iconUrl?: string;
}

const CardExtraIcon: React.FC<Props> = ({ type, iconUrl }) => {
	const iconName = type === 'loyalty' ? 'loyalty2' : type;

	const iconPath = iconUrl || `CardExtra/${iconName}.svg`;
	const iconFallbackPath = `https://cdn.websky.aero/content/frontend/images/ZZ/${iconPath}`;

	return <CdnImage path={iconPath} fallbackUrl={iconFallbackPath} />;
};

export default CardExtraIcon;
